// Heatmap of estimator engagement by day-of-week × hour-of-day.
// Shows Hannah exactly when agents are most engaged so she can time
// outbound calls and ad spend.

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const HOUR_BUCKETS = [0, 3, 6, 9, 12, 15, 18, 21];

function tint(count, max) {
  if (!max || !count) return { background: "#F7F2ED", text: "#C9BEB4" };
  const t = count / max;
  // Interpolate from #F4EEE8 (light) to #2A1C14 (deep espresso)
  const lerp = (a, b) => Math.round(a + (b - a) * t);
  const bg = `rgb(${lerp(244, 42)}, ${lerp(238, 28)}, ${lerp(232, 20)})`;
  const text = t > 0.55 ? "#F3D8DA" : "#5A3B31";
  return { background: bg, text };
}

export default function EstimatorHeatmap({ heatmap }) {
  if (!heatmap || heatmap.length !== 7) {
    return null;
  }
  const max = Math.max(1, ...heatmap.flat());
  return (
    <div className="rounded-2xl bg-white border border-[#E8DFD8] p-5 mt-4" data-testid="funnel-heatmap">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-4">
        <div>
          <p className="overline">Engagement Heatmap</p>
          <h3 className="font-serif-lux text-xl mt-1 text-[#2A1C14]">
            When agents engage
          </h3>
          <p className="text-[11px] text-[#8C7A70] mt-1">
            Unique sessions per hour · darker = more engagement · times shown in your local timezone
          </p>
        </div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.14em] text-[#8C7A70]">
          <span>Low</span>
          <div className="flex">
            {[0.1, 0.3, 0.55, 0.8, 1].map((t) => {
              const lerp = (a, b) => Math.round(a + (b - a) * t);
              return (
                <div
                  key={t}
                  className="w-4 h-3"
                  style={{ background: `rgb(${lerp(244, 42)}, ${lerp(238, 28)}, ${lerp(232, 20)})` }}
                />
              );
            })}
          </div>
          <span>High</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="inline-grid gap-1" style={{ gridTemplateColumns: "40px repeat(24, minmax(20px, 1fr))" }}>
          <div />
          {Array.from({ length: 24 }).map((_, h) => (
            <div
              key={h}
              className={`text-[9px] text-[#8C7A70] text-center ${HOUR_BUCKETS.includes(h) ? "" : "opacity-40"}`}
            >
              {HOUR_BUCKETS.includes(h) ? h : ""}
            </div>
          ))}
          {DAYS.map((day, d) => (
            <>
              <div key={`d-${d}`} className="text-[10px] text-[#5A3B31] font-medium flex items-center">
                {day}
              </div>
              {heatmap[d].map((count, h) => {
                const { background, text } = tint(count, max);
                return (
                  <div
                    key={`c-${d}-${h}`}
                    title={`${day} ${h}:00 — ${count} session${count === 1 ? "" : "s"}`}
                    className="aspect-square rounded-[3px] flex items-center justify-center text-[9px] font-semibold transition-transform hover:scale-110"
                    style={{ background, color: text }}
                    data-testid={`heatmap-${d}-${h}`}
                  >
                    {count > 0 ? count : ""}
                  </div>
                );
              })}
            </>
          ))}
        </div>
      </div>
    </div>
  );
}
